import { useCheckPageComponentAccess } from "@src/hooks/index";
import { AiFillEdit } from "react-icons/ai";
import { MdQrCode2 } from "react-icons/md";

type Props = {
  handleOpen: any;
  kit: any;
};

const ClientKitCardHeader = (props: Props) => {
  const { handleOpen, kit } = props;
  return (
    <div className="client-kit-card-header-container">
      <div className="client-kit-card-header-left">
        <div className="client-kit-card-icon">
          <MdQrCode2 />
        </div>
        <div className="client-kit-card-header-text">
          <span className="client-kit-card-header-label">Kit Reference</span>
          <h4 className="client-kit-card-header-title">
            {kit?.referenceId?.toUpperCase()}
          </h4>
        </div>
      </div>
      {useCheckPageComponentAccess("edit_client_kit_action") && (
        <button
          type="button"
          className="client-kit-card-header-edit"
          aria-label="Edit kit"
          onClick={() => handleOpen(kit)}
        >
          <AiFillEdit size={16} />
        </button>
      )}
    </div>
  );
};

export default ClientKitCardHeader;
